import "./index.scss";

const Skleton = () => {
  return <div className="custom__skleton__loading" />;
};

export default Skleton;
